<template lang="pug">
  
  div.container
    
    .half-width.margin-auto
      h3.title ¿Olvidaste tu contraseña?

      article.message.is-info
        .message-body
          | Ingresa tu DNI y te enviaremos un email para restrablecer tu contraseña 
          
      .field
        p.control.has-icons-left.has-icons-right
          input.input(type='text', placeholder='DNI', v-model="username", @keyup.enter="restablecer")
          span.icon.is-small.is-left
            i.fa.fa-user
            
      router-link.link(to="/") Ir al login

      .field
        p.control.has-text-centered
          button.button.is-primary(@click="restablecer", :class="{'is-loading': isLoading}") Restablecer contraseña
      

      transition(name="fade")
        article.message.is-danger(v-if="errorMessage")
          .message-body
            strong {{errorMessage}}
          
</template>

<script>
// import data from '../util/data'
import { apiPost, notify } from '../util/general'
export default {
  name: 'forgot-password-request',
  data () {
    return {
      username: '',
      errorMessage: '',
      isLoading: false
    }
  },
  methods: {
    restablecer () {
      var vm            = this
      this.isLoading    = true
      this.errorMessage = ''

      var obj = {
        username: this.username
      }

      apiPost(vm, '/forgot-password-request', obj, function (data) {
        notify(vm, 'success', 'Hemos enviado un email ' + data.email + ' con las indicaciones para restablecer la contraseña')
        // vm.username     = ''
        vm.errorMessage = ''
      }, function (error) {
        vm.errorMessage = error.message
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .link
    display inline-block
    margin-bottom 10px
    color #565cde
</style>



// WEBPACK FOOTER //
// View_Forgot_Password_Request.vue?494fdc98